import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { AddressConfirmationFormValues } from "./types";

export const validationSchema: yup.SchemaOf<AddressConfirmationFormValues> = yup.object().shape({
  address: yup.string().required(i18n.t(Translations.AddressFormAddressRequired)),
  address2: yup.string(),
  city: yup.string().required(i18n.t(Translations.AddressFormCityRequired)),
  state: yup.string().required(i18n.t(Translations.AddressFormStateRequired)),
  zipCode: yup.string().required(i18n.t(Translations.AddressFormZipCodeRequired)),
  country: yup.string().required(i18n.t(Translations.AddressFormCountryRequired)),
});
